var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showHeader)?_c('GlobalHeader'):_vm._e(),(_vm.invalidRouteFlag)?_c('InvalidRoute'):_c('router-view'),(_vm.showHeader)?_c('GlobalFooter'):_vm._e(),_c('CommonDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }